module.exports = __webpack_public_path__ + "img/Fight.a134e63f.png";